import PropTypes from 'prop-types';
import React from 'react';

function FacebookSVG({ width, height, fill }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.38151 7.07143L8.71484 4.71429H5.71484V3.37857C5.71484 2.67143 6.46484 2.35714 7.46484 2.35714H8.21484V0.0785713C8.21484 0.0785713 7.13151 0 6.21484 0C4.29818 0 3.21484 1.1 3.21484 3.14286V4.71429H0.714844V7.07143H3.21484V12.5714H5.71484V7.07143H8.38151Z"
        fill={fill}
      />
    </svg>
  );
}

FacebookSVG.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

export default FacebookSVG;
